import { defineComponent as _defineComponent } from 'vue'
import { DeviceStateData } from '@/models/deviceStateData';
import OverviewDeviceCardKpi from './OverviewDeviceCardKpi.vue';
import { isNil } from '@/utils/misc';
import { computed } from 'vue';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'OverviewDeviceCardStateKpi',
  props: {
    label: null,
    deviceState: null,
    metric: null
  },
  setup(__props: any) {

const props = __props as {
  label: string | TranslateResult;
  deviceState: DeviceStateData<T> | undefined;
  metric: keyof DeviceStateData<T>;
};



const metricValue = computed(
  () => props.deviceState?.[props.metric] as number | null,
);

const isMetricNil = computed(() => isNil(metricValue.value));

// The compiler won't let me use the TS non null assertion (!) so I had to create this computed property :(
const nonNullAssertedMetricValue = computed(() => metricValue.value!);

return { __sfc: true,props, metricValue, isMetricNil, nonNullAssertedMetricValue, OverviewDeviceCardKpi }
}

})